import React, { Component } from 'react';
import PropTypes from 'prop-types';

import imgLoadingDark from 'images/loading-thin-24.svg';
import imgLoadingLight from 'images/loading-thin-24-white.svg';

import Text from 'components/Text';

import '../Loader/loader.styles.scss';
import './button.styles.scss';
import { getText } from 'helpers/i18n';

/**
 * General button component with WCAG support and multiple themes.
 * @example ../../examples/Button.md
 */
export default class Button extends Component {
    render() {
        const { theme, text, textOptions, icon, iconOnly, iconToTheRight, isLoading, ariaLabel, onClick, className, type, translate, ...other } = this.props;

        const classes = 'button button--' + theme + ' ' + (className ? className : '');
        const imgLoading = theme && theme === 'primary' ? imgLoadingLight : imgLoadingDark;
        const altLabel = Object.prototype.hasOwnProperty.call(window.Checkout.text, text) ? getText(text) : text;

        return (
            <button
                type={type || 'button'}
                disabled={isLoading}
                className={classes}
                onClick={onClick ? onClick.bind(this) : () => {}}
                {...(ariaLabel && ariaLabel !== altLabel && {'aria-label': ariaLabel})}
                {...other}
            >
                <span className="button__text">
                    {!isLoading && icon && iconOnly &&
                        <img className="button__icon button__icon-only" src={icon} alt={altLabel}/>
                    }
                    {!isLoading && icon && !iconOnly && !iconToTheRight &&
                        <img className="button__icon" src={icon} alt=""/>
                    }
                    {isLoading &&
                        <img className="button__icon ikea-loader__image-spinner" src={imgLoading} alt={getText('loader_text')}/>
                    }
                    {!iconOnly && translate &&
                        <Text textKey={text} options={textOptions} />
                    }
                    {!iconOnly && !translate &&
                        text
                    }
                    {!isLoading && icon && !iconOnly && iconToTheRight &&
                        <img className="button__icon button__icon--right" src={icon} alt=""/>
                    }
                </span>
            </button>
        );
    }
}

Button.propTypes = {
    /** Style theme. Available: unstyled, primary, secondary, secondary-blue, danger */
    theme: PropTypes.string.isRequired,
    /** Text key of the button. */
    text: PropTypes.string,
    textOptions: PropTypes.object,
    /** If text property is a key or plain text */
    translate: PropTypes.bool,
    /** Add button icon. Object with image is required */
    icon: PropTypes.string,
    /** Remove text prop and display only icon */
    iconOnly: PropTypes.bool,
    /** Sets icon placement to the right */
    iconToTheRight: PropTypes.bool,
    /** Show a loading spinner */
    isLoading: PropTypes.bool,
    /** Aria label for accesibility purposes. Optional, if not provided it will default to text */
    ariaLabel: PropTypes.string,
    /** Function to execute upon click */
    onClick: PropTypes.func,
    /** Additional CSS classes */
    className: PropTypes.string,
    type: PropTypes.string,
};

Button.defaultProps = {
    translate: true,
};
